export default "__VITE_ASSET__BbA6q4cO__"